import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { getadvLocation } from "@/api/dataAll/advLocation";
import addpaySdkConfig from "./components/addpaySdkConfig";
import { paysdkconfig, delsdkconfig, resetsdkconfig } from "@/api/aymentsdk/aymentsdk";
export default {
  name: "paySdkConfig",
  components: {
    addpaySdkConfig: addpaySdkConfig
  },
  data: function data() {
    return {
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      // advchannels:[],
      showing: false,
      gameId: "",
      value1: "",
      value2: [],
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "" // advChannel:'',

      },
      searchMark: {},
      tableData: [],
      addpaySdkConfig: false,
      total: 0,
      page: 1,
      show: false
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    handleJoinPeople: function handleJoinPeople(a) {
      var _this2 = this;

      var tid = {
        id: a.id
      };
      this.$alert("<strong>\u5BC6\u94A5ID:<i>".concat(a.secret_key_id, "</i></strong></br><strong>\u5BC6\u94A5key:<i>").concat(a.secret_key_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "重置密钥"
      }).then(function () {
        resetsdkconfig(tid).then(function (res) {
          _this2.$message({
            type: "success",
            message: res.message
          });

          _this2.searchClick();
        });
      });
    },
    callback: function callback(a) {
      this.$alert("<strong>\u56DE\u8C03\u5BC6\u94A5ID:<i>".concat(a.callback_id, "</i></strong></br><strong>\u56DE\u8C03\u5BC6\u94A5key:<i>").concat(a.callback_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true
      });
    },
    changeShow: function changeShow(val) {
      this.showing = false;
    },
    gamechange: function gamechange(id) {
      var _this3 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this3.searchplatforms = res.data;
          _this3.searchData.platform = "";
          _this3.searchData.channel = "";
          _this3.searchData.pkg = "";
          _this3.searchMark.platform = "";
          _this3.searchMark.channel = "";
          _this3.searchMark.pkg = ""; // this.searchData.advChannel = '';

          _this3.searchData.advLocation = "";
          _this3.searchMark.ad_placement = "";
          _this3.searchMark.ad_channel = "";
          _this3.searchchannels = []; // this.advchannels = [];

          _this3.advLocation = [];
          _this3.searchpkgs = [];

          _this3.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = ""; // this.searchData.advChannel = '';

        this.searchData.advLocation = "";
        this.searchMark.ad_channel = "";
        this.searchMark.ad_placement = ""; // this.advchannels = [];

        this.advLocation = [];
      }
    },
    platformchange: function platformchange(id) {
      var _this4 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this4.searchchannels = res.data.channel; // this.advchannels=res.data.adv_platform;//广告平台

          _this4.searchData.channel = "";
          _this4.searchData.pkg = ""; // this.searchData.advChannel='';

          _this4.searchData.advLocation = "";
          _this4.searchMark.channel = "";
          _this4.searchMark.pkg = "";
          _this4.searchMark.ad_placement = "";
          _this4.searchMark.ad_channel = "";
          _this4.advLocation = [];
          _this4.searchpkgs = [];

          _this4.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.platform = item.platform_mark;
              _this4.searchData.channel = "";
              _this4.searchMark.channel = "";
            }
          });
        });
      } else {
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = []; // this.searchData.advChannel = '';

        this.searchData.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = ""; // this.advchannels = [];

        this.advLocation = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this5 = this;

      if (id != "") {
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this5.searchpkgs = res.data;

          _this5.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this5.searchMark.channel = item.channel_mark;
              _this5.searchData.pkg = "";
              _this5.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this6 = this;

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this6.searchMark.pkg = item.pkg_mark;
          }
        });
      } else {
        this.searchMark.pkg = "";
      }
    },
    // advChannelchange(id){
    //      if (id!='') {
    //     getadvLocation({ advplatform_id: id }).then((res) => {
    //       this.advLocation = res.data;
    //       this.searchMark.ad_channel='';
    //       this.advchannels.forEach((item) => {
    //         if (item.id == id) {
    //           this.searchMark.ad_channel = item.adv_platform_mark
    //            this.searchData.advLocation = '';
    //           this.searchMark.ad_placement = '';
    //         }
    //       })
    //     })
    //   } else {
    //      this.searchData.advLocation = '';
    //     this.searchMark.ad_placement = '';
    //     this.searchMark.ad_channel = '';
    //     this.searchData.advChannel = '';
    //     this.advLocation = [];
    //   }
    // },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this7 = this;

      paysdkconfig(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this7.tableData = res.data.data.length ? _this7.$utils.dataConversion(res.data.data, list) : [];
          _this7.total = res.data.total || 0;
          _this7.show = true;
        }
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addpaySdkConfig.init(id);
    },
    handleDelete: function handleDelete(id) {
      var _this8 = this;

      this.$confirm("此操作将删除该支付sdk配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delsdkconfig({
                  id: id
                }).then(function (res) {
                  _this8.searchClick();
                });

                _this8.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};